import React from 'react';
import PropTypes from 'prop-types';
import { FormControlLabel, Checkbox as MaterialCheckbox } from '@mui/material';

export default function Checkbox({ checked, onCheck, label, disabled }) {
  return label ? (
    <FormControlLabel
      checked={checked}
      control={<MaterialCheckbox
        onChange={(evt, checked) => onCheck(checked)}
      />}
      label={label}
      disabled={disabled}
    />
  ) : (
    <MaterialCheckbox
      checked={checked}
      onChange={(evt, checked) => onCheck(checked)}
      disabled={disabled}
      sx={{
        color: '#5BC4BF',
        '&.Mui-checked': {
          color: '#5BC4BF',
        },
      }}
    />
  );
}

Checkbox.propTypes = {
  checked: PropTypes.bool,
  onCheck: PropTypes.func.isRequired,
  label: PropTypes.node,
  disabled: PropTypes.bool
}
